import SubscriptionCard from './SubscriptionCard';

export default SubscriptionCard; 